import { CommonButton as Button } from 'components/common/Forms/Button';
import { RowActions } from 'components/Table/Table.styled';
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa';
import { Column } from 'react-table';
import {
  ApptOption,
  ApptOptionResponseData,
  ApptOptionsFilters,
} from 'types/apptOptions';
import { FetchedDataTable } from 'components/Table/FetchedDataTable';
import { PaginatedFiltersWithSet } from 'hooks/usePaginatedFilters';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { getFilterControls } from 'components/Table/TableUtils';
import { useApptOptionsColumns } from 'hooks/lists/useApptOptionsColumns';

type Props = {
  apptOptionsData?: ApptOptionResponseData;
  openFormHandler: (value?: string) => void;
  handleDeleteApptOption: (value: string) => void;
  isLoading: boolean;
  isFetching: boolean;
} & PaginatedFiltersWithSet<ApptOptionsFilters>;

export const ApptOptionsTable = ({
  apptOptionsData,
  openFormHandler,
  handleDeleteApptOption,
  setFilters,
  isLoading,
  filters,
  isFetching,
}: Props) => {
  const { t } = useCommonTranslation();

  const columns = useApptOptionsColumns({
    lastColumn: {
      ...getFilterControls({ filters, setFilters, t }),
      Cell: ({ value }: { value: string }) => {
        return (
          <RowActions>
            <Button
              iconOnly
              variant="primary"
              title={t('edit-appointment-option')}
              type="button"
              onClick={() => openFormHandler(value)}
            >
              <FaPencilAlt />
            </Button>
            <Button
              iconOnly
              variant="danger"
              title={t('remove-appointment-option')}
              type="button"
              onClick={() => {
                handleDeleteApptOption(value);
              }}
            >
              <FaTrashAlt />
            </Button>
          </RowActions>
        );
      },
    } as Column<ApptOption>,
  });

  return (
    <FetchedDataTable
      columns={columns}
      data={apptOptionsData}
      isLoading={isLoading}
      isFetching={isFetching}
      filters={filters}
      onSortOrPageChange={setFilters}
    />
  );
};
